// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"05be32a04ff4196fc568","655":"03ff04bb9bc055fc9f08"}[chunkId] + ".js";
};